import "$styles/index.scss"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

addEventListener('DOMContentLoaded', () => {
  const navbar = document.querySelector('.navbar')
  const header = document.querySelector('header')
  header.style.height = `${navbar.scrollHeight}px`
})